import { render, staticRenderFns } from "./SaffronContract.vue?vue&type=template&id=d265cca6&scoped=true&"
import script from "./SaffronContract.vue?vue&type=script&lang=js&"
export * from "./SaffronContract.vue?vue&type=script&lang=js&"
import style0 from "./SaffronContract.vue?vue&type=style&index=0&id=d265cca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d265cca6",
  null
  
)

export default component.exports